/**
 * Product branding and runtime configuration.
 * QuietVia is a working name — change values here (or via env) without editing workflows.
 */
export type ProductConfig = {
  /** Display name shown in UI chrome */
  displayName: string;
  /** Short neutral description / tagline (prototype copy — SME review before pilot) */
  shortDescription: string;
  /** Public origin when known (localhost / SWA hostname). Empty until configured. */
  publicBaseUrl: string;
  /** Optional future contact fields — unused in scaffold */
  supportEmail: string;
  privacyEmail: string;
  /** PWA / manifest short name */
  pwaShortName: string;
  /** PWA / manifest full name */
  pwaName: string;
  /** Bland Quick Exit destination (SME-reviewed later). Prototype placeholder. */
  quickExitUrl: string;
};

function fromEnv(name: string, fallback: string): string {
  const value = import.meta.env[name];
  return typeof value === "string" && value.length > 0 ? value : fallback;
}

const defaultTagline = "Information, options, and support — privately.";

export const productConfig: ProductConfig = {
  displayName: fromEnv("VITE_PRODUCT_DISPLAY_NAME", "QuietVia"),
  shortDescription: fromEnv("VITE_PRODUCT_SHORT_DESCRIPTION", defaultTagline),
  publicBaseUrl: fromEnv("VITE_PUBLIC_BASE_URL", ""),
  supportEmail: fromEnv("VITE_SUPPORT_EMAIL", ""),
  privacyEmail: fromEnv("VITE_PRIVACY_EMAIL", ""),
  pwaShortName: fromEnv("VITE_PWA_SHORT_NAME", "Support"),
  pwaName: fromEnv("VITE_PWA_NAME", defaultTagline),
  quickExitUrl: fromEnv("VITE_QUICK_EXIT_URL", "https://www.wikipedia.org/"),
};
